export const waitsFor = (timeout: number) =>
  new Promise((resolve) => {
    setTimeout(resolve, timeout);
  });
